import BottomNav from "../../../../components/BottomNav";
import DesktopNav from "../../../../components/DesktopNav";
import { HomeScreenType } from "../../../../helpers/Enums";
import BounakirWatchMeCarpet from "./BounakirWatchMeCarpet";

export function BounakirWatchMeContainer() {
  return (
    <div>
      <BounakirWatchMeCarpet />
      <DesktopNav screenType={HomeScreenType.BOUNAKIR_WATCH_ME} />
      <BottomNav screenType={HomeScreenType.BOUNAKIR_WATCH_ME} />
    </div>
  );
}

// export function BounakirWatchMeContainer() {
//     return (
//         <div>
//             <BounakirWatchMeCarpet />
//             <DesktopNav screenType={HomeScreenType.BOUNAKIR} />
//             <BottomNav screenType={HomeScreenType.BOUNAKIR} />
//         </div>
//     )
// }

export default BounakirWatchMeContainer;
